export default __webpack_public_path__ + "static/media/Oudergem2.405ac5d4.png";